import { FC } from 'react';
import { FormControlLabelProps, FormControlLabel as MuiFormControlLabel } from '@mui/material';

export const FormControlLabel: FC<FormControlLabelProps> = props => {
  return <MuiFormControlLabel {...props} />;
};
